
'use strict';

var searchPartMixin = require('../modules/mixins/searchpart.mixin');
var viewConfig;
var modelStrategy;
var viewStrategy;
const xsellUtils = require('od-modules/utils/xsell.utils');

module.exports = Odigeo.Widget.extend({
    modelClass: Odigeo.Model.extend(searchPartMixin.extend({
        type: 'itinerary',
        strategy: {},
        defaults: {
            dates: [],
            relatedDates: [],
        },
        init: function() {
            this.options = Odigeo.parseOptions(this.widget.options);
            this.setType();

            return searchPartMixin.getMixin().init.apply(this, arguments);
        },

        bindCustomEvents: function() {
            this.on('changeDates', this.save);

            if (this.options.isRelatedCalendar) {
                this.on('sync:fetch', this.checkEqualDates);
                this.on('changeSearchModel', this.onChangeSearchModel);
            }

            return this;
        },

        onChangeSearchModel: function(model) {
            if (Odigeo._.has(model.changed, 'searchSegments')) {
                this.setRelatedDates(Odigeo._.map(model.get('searchSegments'), 'dateStr'));
            }

            return this;
        },

        clear: function() {
            var result = Odigeo.Model.prototype.clear.apply(this, arguments);
            this.setDefaults().trigger('clear');

            return result;
        },

        parse: function(attrs) {
            return this.strategy.fetch(attrs);
        },

        pushParse: function(model, originalData) {
            return this.strategy.save(this.get('dates'), originalData);
        },

        getDateRange: function(index) {
            return this.strategy.getDateRange(this.toJSON(), index);
        },

        getErrorsDates: function() {
            return Odigeo._.filter(this.getErrors(), function(error) {
                return Odigeo._.includes(this.strategy.errorKeys, error.key) && Odigeo._.isString(error.type);
            }, this);
        },

        setType: function() {
            var searchParameters = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'));
            this.type = Odigeo._.isEqual(this.options.type, 'accommodation') ?
                this.setAcommodationTrip(searchParameters) :
                this.options.type || this.type;
            this.strategy = modelStrategy[this.type];

            return this;
        },

        setAcommodationTrip: function(searchParameters) {
            this.options.isRelatedCalendar = Odigeo._.isEqual(searchParameters.type, 'roundTrip');
            return this.options.type.concat(Odigeo.Utils.capitalize(searchParameters.type));
        },

        setDefaults: function() {
            this.set(this.defaults);

            return this;
        },

        setDates: function(date, index) {
            var dates;

            if (Odigeo._.isArray(date)) {
                dates = Odigeo._.clone(date);
            } else {
                dates = this.get('dates');
                dates[index] = date;
            }
            this.set('dates', dates).trigger('changeDates');

            return this;
        },

        setRelatedDates: function(dates) {
            if (!Odigeo._.isEqual(formatDates('formatDate', this.get('relatedDates')), dates)) {
                this.set('relatedDates', formatDates('parseDate', dates))
                    .checkDatesWithRelatedDates().trigger('changeRelatedDates');
            }

            return this;
        },

        setDatesWithRelated: function() {
            if (this.options.isRelatedCalendar) {
                this.setDates(this.get('relatedDates')).trigger('updateDatesWithRelated');
            }

            return this;
        },

        getUpsellAccommodationCustomSearchDates: function() {
            const {departureDate} = xsellUtils.getItineraryDatesFromSearchParams();
            const customCheckoutDate = xsellUtils.getPricePerceptionCheckoutDateStr(departureDate);

            return [new Date(departureDate), new Date(customCheckoutDate)];
        },

        setUpsellAccommodationCustomSearchDates: function() {
            if (this.options.isRelatedCalendar) {
                this.setDates(this.getUpsellAccommodationCustomSearchDates()).trigger('updateDatesWithRelated');
            }
        },

        checkAccommodationDates: function() {
            var isTypeAccommodation = this.type === 'accommodationRoundTrip';
            const improveXSellPricePerception = this.options.canImprovePricePerception && xsellUtils.canImprovePricePerception();
            var hasValidRelatedDates = improveXSellPricePerception
                ? this.hasValidRelatedDates(this.getUpsellAccommodationCustomSearchDates())
                : this.hasValidRelatedDates();

            if (isTypeAccommodation && this.isEmptyDates() && hasValidRelatedDates) {
                improveXSellPricePerception ? this.setUpsellAccommodationCustomSearchDates() : this.setDatesWithRelated();
            }

            return this;
        },

        cleanDates: function() {
            this.setDates(Odigeo._.map(this.get('dates'), Odigeo._.constant(''))).trigger('clear');

            return this;
        },

        checkDatesWithRelatedDates: function() {
            if (!this.options.isRelatedCalendar) {
                return this;
            }
            var relatedDates = this.get('relatedDates');

            if (!this.hasValidRelatedDates()) {
                this.cleanDates().trigger('updateDatesWithRelated');
            } else if (this.hasValidDates()) {
                this.setDates(Odigeo._.map(this.get('dates'), function(date, index) {
                    return getDateCompared(relatedDates[index], date, index === 0);
                })).trigger('updateDatesWithRelated');
            }

            return this;
        },

        checkEqualDates: function() {
            if (this.options.canImprovePricePerception && xsellUtils.canImprovePricePerception()) {
                return this;
            } else if (!this.hasUniqueDates()) {
                this.cleanDates();
            }

            return this;
        },

        isEmptyDates: function() {
            return Odigeo._.isEmpty(this.get('dates')) || !Odigeo._.some(this.get('dates'), Odigeo._.isDate);
        },

        hasValidRelatedDates: function(relatedDates = this.get('relatedDates')) {
            return Odigeo._.every(this.get('relatedDates'), Odigeo._.isDate) &&
                Odigeo.Utils.getDifferenceInDays.apply(Odigeo.Utils, getTimes(relatedDates)) >= 1;
        },

        hasValidDates: function() {
            return !this.isEmptyDates() && Odigeo._.every(this.get('dates'), Odigeo._.isDate);
        },

        hasUniqueDates: function() {
            return this.options.isRelatedCalendar ?
                !Odigeo._.isEqual(this.get('dates'), this.get('relatedDates')) : true;
        },

        hasOutdatedDates: function() {
            return !Odigeo._.isEmpty(Odigeo._.find(this.getErrorsDates(), {type: 'outdate'}));
        },

        hasErrors: function() {
            return !Odigeo._.isEmpty(this.getErrorsDates());
        },

        hasError: function(errorType) {
            return Odigeo._.chain(this.getErrorsDates()).find({type: errorType}).isObject().value();
        },

        isLastDayOfMonth: function(selectedDate) {
            var lastDayOfMonth = new Date(Date.UTC(selectedDate.getUTCFullYear(), selectedDate.getMonth() + 1, 0));
            return selectedDate.getDate() === lastDayOfMonth.getDate();
        },
    })),

    viewClass: Odigeo.View.extend({
        templateSettings: {
            evaluate: /\{\{#([\s\S]+?)\}\}/g,
            interpolate: /\{\{[^#{]([\s\S]+?)[^}]\}\}/g,
            escape: /\{\{\{([\s\S]+?)\}\}\}/g,
        },

        tmpls: {
            error: '.calendar_error_template',
            date: '.calendar_date_template',
        },

        slctrs: {
            errorWrapper: '.calendar_error_wrapper',
            calendarWrapper: '.calendar_search_wrapper',
            collapseCheckBox: '.calendar_collapse_checkbox',
            collapseLabel: '.calendar_collapse_label',
            calendars: '.calendar_search',
            calendar0: '#calendar0',
            calendar1: '#calendar1',
            outbound: '.calendar_search0',
            inbound: '.calendar_search1',
        },

        events: {
            'change .calendar_search': 'changeHandler',
            'change .calendar_collapse_checkbox': 'changeCollapseCheckBoxHandler',
            'click .calendar_done_btn': 'onDone',
        },

        init: function() {
            this.options = Odigeo.parseOptions(this.widget.options);
            this.setStrategy().bindEvents().initCollapse();

            return this;
        },

        setStrategy: function() {
            this.strategy = viewStrategy[this.model.type];

            return this;
        },

        bindEvents: function() {
            this.listenTo(this.model, 'clear', this.clear);
            this.listenTo(this.model, 'updateDatesWithRelated', this.render);
            this.listenTo(this.model, 'changeRelatedDates', this.checkCollapseLauncher);
            this.listenTo(this.model, 'sync:fetch', this.syncHandler);
            this.listenTo(this.model, 'error', this.checkErrors);

            return this;
        },

        clear: function() {
            this.clearErrors().toggleCollapse(false).checkCollapseLauncher();

            return this;
        },

        render: function() {
            if (this.isEmptyCalendar()) {
                this.renderTemplate(this.tmpls.date, this.slctrs.calendarWrapper)
                    .setCalendarPickers();
            } else if (!this.isEmptyCalendar()) {
                this.refreshCalendars();
            }
            this.checkErrors();
            this.model.checkAccommodationDates();

            return this;
        },

        renderTemplate: function(selTmpl, wrapperTmpl, data) {
            var tmpl = Odigeo._.template(this.$(selTmpl).html(), this.templateSettings);
            var dataTmpl = Odigeo._.extend({}, data || this.model.toJSON(), viewConfig, this.strategy.config);

            this.$(wrapperTmpl).html(tmpl(dataTmpl));

            return this;
        },

        renderError: function(err) {
            var $wrapper = this.$(this.slctrs.errorWrapper);

            this.$el.addClass('invalid');
            $wrapper.removeClass(viewConfig.hiddenClass);
            this.renderTemplate(
                this.tmpls.error,
                this.slctrs.errorWrapper,
                {msg: $wrapper.data(err.type), errorType: err.type}
            );

            return this;
        },

        getConfigPicker: function(segment, options) {
            var isValid = !this.model.hasOutdatedDates();
            return Odigeo._.extend({silent: true}, segment, {
                dates: isValid ? this.model.getDateRange(segment.calendarIndex) : ['', ''],
                relatedDates: isValid ? this.model.getDateRange(segment.calendarIndex === 1 ? 0 : 1) : ['', ''],
                value: isValid ? this.model.get('dates')[segment.calendarIndex] : '',
                calendarType: this.model.type,
                enableBlur: !this.options.tabToggle,
            }, options);
        },

        setCalendarPickers: function() {
            Odigeo._.each(this.strategy.config.segments, function(segment, key) {
                var $calendar = this.$(this.slctrs[key]);
                Odigeo.UIElements.enhanceDatepicker($calendar, this.getConfigPicker(segment));
                $calendar.trigger('refresh');
            }, this);
            return this;
        },

        isEmptyCalendar: function() {
            return Odigeo._.size(this.$(this.slctrs.calendars)) === 0;
        },

        refreshCalendars: function(options) {
            Odigeo._.each(Odigeo._.omit(this.strategy.config.segments, Odigeo._.result(options, 'omit')), function(segment, key) {
                this.$(this.slctrs[key]).trigger('config', this.getConfigPicker(segment, {refresh: true}));
            }, this);

            return this;
        },

        clearErrors: function() {
            this.$(this.slctrs.calendars).trigger('clearError');

            return this;
        },

        checkErrors: function() {
            this.$(this.slctrs.errorWrapper).addClass(viewConfig.hiddenClass);
            this.$el.removeClass('invalid');
            if (this.model.hasError('incomplete')) {
                this.$(this.slctrs.inbound).trigger('open');
            }

            if (this.model.hasErrors()) {
                this.refreshErrors();
                this.refreshCalendars();
            }

            return this;
        },

        refreshErrors: function() {
            Odigeo._.each(this.model.getErrorsDates(), function(err) {
                this.renderError(err);
            }, this);

            return this;
        },

        getErrorState: function() {
            var $wrapper = this.$(this.slctrs.errorWrapper);

            return Odigeo._.some(this.model.getErrorsDates(), function(err) {
                return !Odigeo._.isEmpty($wrapper.data(err.type));
            }, this) ? 'error' : 'incomplete';
        },

        initCollapse: function() {
            var collapseId = Odigeo._.uniqueId(this.widget.id);
            if (this.options.collapsible) {
                this.$(this.slctrs.collapseCheckBox).attr('id', collapseId);
                this.$(this.slctrs.collapseLabel).attr('for', collapseId);
            }

            return this;
        },

        checkCollapseLauncher: function() {
            if (!this.options.collapsible) {
                return this;
            }
            var $checkbox = this.$(this.slctrs.collapseCheckBox);

            if (this.model.hasValidRelatedDates()) {
                $checkbox.removeAttr('disabled');
            } else {
                $checkbox.attr('disabled', true);
            }

            return this;
        },

        toggleCollapse: function(hasToShow) {
            if (this.options.collapsible) {
                this.$(this.slctrs.collapseCheckBox).prop('checked', hasToShow);
                this.$(this.slctrs.calendarWrapper).toggleClass(viewConfig.hiddenClass, !hasToShow);
            }

            return this;
        },

        syncHandler: function() {
            this.render().toggleCollapse(this.model.hasValidDates()).checkCollapseLauncher();
        },

        changeHandler: function(evt, data) {
            var $picker = $(evt.target);
            var dates = this.options.isRelatedCalendar ? data.selectedDate : data.dates;

            this.model.setDates(dates, $picker.data('calendarIndex'));
            this.clearErrors().refreshCalendars({omit: $picker.data('key')});

            if (this.model.hasErrors()) {
                this.$(this.slctrs.inbound).trigger('error', this.getErrorState());
                if (this.options.tabToggle) {
                    this.$(this.slctrs.inbound).trigger('open');
                }
                if (this.options.skipMonth && $picker[0].name === '0' && this.model.isLastDayOfMonth(dates[0])) {
                    this.$(this.slctrs.inbound).trigger('skipMonth');
                }
            } else {
                Odigeo.trigger(this.widget.id + ':close');
            }
        },

        changeCollapseCheckBoxHandler: function(evt) {
            var isChecked = $(evt.target).prop('checked');
            var modelMethod = isChecked ? 'setDatesWithRelated' : 'cleanDates';

            Odigeo.trigger(this.widget.name + ':separateStayChecked');

            this.model[modelMethod]();
            this.toggleCollapse(isChecked);

            return this;
        },

        switchTab: function(tab) {
            this.$el.find(this.slctrs[tab === 'departure' ? 'outbound' : 'inbound']).trigger('open');
            this.$el.find(this.slctrs[tab !== 'departure' ? 'outbound' : 'inbound']).trigger('close');
            return this;
        },

        onDone: function() {
            if (this.model.hasErrors() && !this.model.hasError('incomplete')) {
                this.$(this.slctrs.inbound).trigger('error', this.getErrorState());
            } else {
                Odigeo.trigger(this.widget.id + ':close');
            }
        },
    }),

    switchTab: function(activeTab) {
        this.view.switchTab(activeTab);
    },
});

function formatDate(formater, date) {
    var validArguments = !Odigeo._.isNull(date) && Odigeo._.isFunction(Odigeo.Utils[formater]);
    var validFormatter =
        (Odigeo._.isEqual(formater, 'parseDate') && isValidDateString(date)) || (Odigeo._.isEqual(formater, 'formatDate') && Odigeo._.isDate(date));

    if (validArguments && validFormatter) {
        return formater === 'parseDate' ?
            Odigeo.Utils.parseDate(date, Odigeo.Utils.formatDate.masks.isoDate) :
            Odigeo.Utils.formatDate(date, 'isoDate', true);
    } else {
        return Odigeo._.clone(date);
    }
}

function formatDates(formater, dates) {
    return Odigeo._.map(dates, Odigeo._.partial(formatDate, formater));
}

function getDateCompared(date1, date2, shouldBeSuperior) {
    var mathMethod = shouldBeSuperior ? 'max' : 'min';

    return new Date(Math[mathMethod](date1.getTime(), date2.getTime()));
}

function getTimes(dates) {
    return Odigeo._.map(dates, function(date) {
        return date.getTime();
    });
}

function isValidDateString(dateString) {
    return Odigeo._.isString(dateString) && !Odigeo._.isNaN(Date.parse(dateString));
}

viewConfig = {
    hiddenClass: 'odf-hidden',
    uiClass: 'calendar-changesearch',
    type: 'dual',
    silent: true,
    hover: true,
    specialToOpen: true,
    variableHeight: true,
    icon: 'z',
};
viewStrategy = (function(strategy) {
    strategy = {
        itinerary: {
            config: {
                segments: {
                    outbound: {
                        tabIndex: 14,
                        side: 'left',
                        index: 0,
                        calendarIndex: 0,
                        permissible: true,
                        key: 'departure',
                    },
                    inbound: {
                        hide: 'ow',
                        tabIndex: 15,
                        isSpecialOpen: true,
                        side: 'right',
                        index: 1,
                        calendarIndex: 1,
                        permissible: true,
                        key: 'return',
                    },
                },
            },
        },
        separatestay: {
            config: {
                segments: {
                    outbound: {
                        key: 'checkin',
                        side: 'left',
                        tabIndex: 17,
                        permissible: false,
                        index: 1,
                        calendarIndex: 0,
                        useMax: true,
                    },
                    inbound: {
                        key: 'checkout',
                        hide: 'ow',
                        side: 'right',
                        tabIndex: 18,
                        permissible: false,
                        index: 1,
                        calendarIndex: 1,
                        useMax: true,
                    },
                },
            },
        },
        accommodationRoundTrip: {
            config: {
                segments: {
                    outbound: {
                        key: 'checkin',
                        side: 'left',
                        tabIndex: 17,
                        permissible: false,
                        index: 1,
                        calendarIndex: 0,
                        useMax: true,
                    },
                    inbound: {
                        key: 'checkout',
                        hide: 'ow',
                        side: 'left',
                        tabIndex: 18,
                        permissible: false,
                        index: 1,
                        calendarIndex: 1,
                        useMax: true,
                    },
                },
            },
        },
        accommodationOneWayTrip: {
            config: {
                segments: {
                    outbound: {
                        key: 'checkin',
                        side: 'left',
                        tabIndex: 17,
                        permissible: true,
                        index: 0,
                        calendarIndex: 0,
                    },
                    inbound: {
                        key: 'checkout',
                        side: 'left',
                        tabIndex: 18,
                        permissible: true,
                        index: 1,
                        calendarIndex: 1,
                    },
                },
            },
        },
    };
    strategy.all = Odigeo._.clone(strategy.itinerary);
    return strategy;
})({});

modelStrategy = (function(strategy) {
    strategy = {
        itinerary: {
            errorKeys: ['date'],
            fetch: function(search) {
                var segments = search.searchSegments || [];

                return {
                    dates: [
                        formatDate('parseDate', Odigeo._.get(segments[0], 'dateStr', '')),
                        formatDate('parseDate', Odigeo._.get(segments[1], 'dateStr', '')),
                    ],
                };
            },

            save: function(newDates, originalData) {
                var pickData = $.extend(true, {}, Odigeo._.pick(originalData, 'searchSegments'));

                pickData.searchSegments[0].dateStr = formatDate('formatDate', newDates[0]);
                pickData.searchSegments[1].dateStr = formatDate('formatDate', newDates[1]);

                return pickData;
            },

            getDateRange: function(model) {
                return model.dates;
            },
        },
        separatestay: {
            errorKeys: ['checkInDates'],
            fetch: function(search) {
                var segments = search.searchSegments || [];

                return {
                    relatedDates: [
                        formatDate('parseDate', Odigeo._.get(segments[0], 'dateStr', '')),
                        formatDate('parseDate', Odigeo._.get(segments[1], 'dateStr', '')),
                    ],
                    dates: [
                        formatDate('parseDate', search.checkInDate),
                        formatDate('parseDate', search.checkOutDate),
                    ],
                };
            },

            save: function(newDates) {
                return {
                    checkInDate: formatDate('formatDate', newDates[0]),
                    checkOutDate: formatDate('formatDate', newDates[1]),
                };
            },

            getDateRange: function(model, index) {
                return [
                    index === 0 ? model.relatedDates[0] : model.dates[0],
                    model.dates[index],
                    index === 0 ? model.dates[1] : model.relatedDates[1],
                ];
            },
        },
        accommodationRoundTrip: {
            errorKeys: ['checkInDates'],
            fetch: function(search) {
                var segments = search.searchSegments || [];

                return {
                    relatedDates: [
                        formatDate('parseDate', Odigeo._.get(segments[0], 'dateStr', '')),
                        formatDate('parseDate', Odigeo._.get(segments[1], 'dateStr', '')),
                    ],
                    dates: [
                        formatDate('parseDate', search.checkInDate),
                        formatDate('parseDate', search.checkOutDate),
                    ],
                };
            },

            save: function(newDates) {
                return {
                    checkInDate: formatDate('formatDate', newDates[0]),
                    checkOutDate: formatDate('formatDate', newDates[1]),
                };
            },

            getDateRange: function(model, index) {
                return [
                    index === 0 ? model.relatedDates[0] : model.dates[0],
                    model.dates[index],
                    index === 0 ? model.dates[1] : model.relatedDates[1],
                ];
            },
        },
        accommodationOneWayTrip: {
            errorKeys: ['checkInDates'],
            fetch: function(search) {
                var segments = search.searchSegments || [];
                var flightDate = Odigeo._.get(segments[0], 'dateStr', '');

                return {
                    dates: [
                        formatDate('parseDate', search.checkInDate ? search.checkInDate : flightDate),
                        formatDate('parseDate', search.checkOutDate ?
                            search.checkOutDate :
                            flightDate ? Odigeo.Utils.getNextDay(flightDate) : ''),
                    ],
                };
            },

            save: function(newDates) {
                return {
                    checkInDate: formatDate('formatDate', newDates[0]),
                    checkOutDate: formatDate('formatDate', newDates[1]),
                };
            },

            getDateRange: function(model) {
                return model.dates;
            },
        },
    };

    strategy.all = Odigeo._.extend({}, strategy.itinerary, {
        errorKeys: ['checkInDates', 'date'],
        save: function(newDates, originalData) {
            var pickData = $.extend(true, {}, Odigeo._.pick(originalData, 'searchSegments'));

            pickData.searchSegments[0].dateStr = formatDate('formatDate', newDates[0]);
            pickData.searchSegments[1].dateStr = formatDate('formatDate', newDates[1]);
            pickData.checkInDate = formatDate('formatDate', newDates[0]);
            pickData.checkOutDate = formatDate('formatDate', newDates[1]);

            return pickData;
        },
    });
    return strategy;
})({});
